<div class="welcome-container">
  <div class="welcome">
    <div class="welcome-header">
      <a routerLink="/" class="logo white marTop20 marLeft20 marRight20"></a>

      <hr class="whiteBG mar20 marLeft40 marRight40 opat25" />

      <div class="whiteT marLeft20 marRight20">
        <div>
          <h1 class="w300">{{ titleText }}</h1>
        </div>
      </div>
    </div>

    <div class="mainBody noPad whiteBG">
      <div class="width100 pad30">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
